import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import { useApolloClient } from "@apollo/client";
import { MUTATION_ACKNOWLEDGE_RISK_SCORE } from "../graphql/mutations";

export const RiskScoreNotification = ({
  rgNotificationData,
  skin,
  player,
  setRgNotificationData,
  pages,
}) => {
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();

  const acknowledgeLooseRiskScore = async (action) => {
    const { errors, data } = await apolloClient.mutate({
      mutation: MUTATION_ACKNOWLEDGE_RISK_SCORE,
      variables: {
        eventType: rgNotificationData.event_type,
        nickName: player.nickName,
        acknowledgeType: action,
      },
      errorPolicy: "all",
    });
    if (errors) {
      toast.error(errors[0].message, {
        position: "bottom-center",
      });
      return false;
    }
    if (data) {
      setRgNotificationData({});
      if (action === "limits") {
        window.location.replace(pages["my-limits"]);
      }
    }
    return true;
  };

  return (
    <StyledModal
      isOpen={rgNotificationData && Object.keys(rgNotificationData).length > 0}
      centered
    >
      <StyledModalBody register>
        {rgNotificationData.event_type && (
          <p
            dangerouslySetInnerHTML={{
              __html: t("label_" + rgNotificationData.event_type.toLowerCase()),
            }}
          ></p>
        )}
      </StyledModalBody>
      <StyledModalFooter>
        <StyledButton
          btnBold
          limit
          pub={skin === "pub"}
          onClick={() => acknowledgeLooseRiskScore("limits")}
        >
          {t("label_limits")}
        </StyledButton>
        <StyledButton
          btnBold
          limit
          pub={skin === "pub"}
          onClick={() => acknowledgeLooseRiskScore("ok")}
        >
          {t("label_ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
